import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/admin/auth/AdminAuthContext";

export function ProtectedRoute() {
  const location = useLocation();
  const { checking, isAuthenticated } = useAdminAuth();

  if (checking) {
    return (
      <div className="admin-shell flex min-h-screen items-center justify-center px-6">
        <div className="rounded-2xl border border-[#dce6fb] bg-white px-5 py-3 text-sm font-medium text-[#44628a]">
          Validating admin session...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}